import * as Yup from 'yup';

export interface UploadDocumentModel {
  documentType: string;
  documentUpload: string;
  documentDate: Date | null;
  startOfWeek?: Date | null;
}

export const initialUploadDocumentValues: UploadDocumentModel = {
  documentType: '',
  documentUpload: '',
  documentDate: null,
  startOfWeek: undefined,
};

export const UploadDocumentModelSchema = Yup.object().shape({
  documentType: Yup.string().required('Please select a document type.'),
  documentUpload: Yup.string().required('Please upload a document.'),
  documentDate: Yup.date()
    .nullable()
    .when('documentType', {
      is: 'MonthlyIncomeExpensesStatement',
      then: (schema) =>
        schema
          .required('Please select a month.')
          .typeError('Please select a valid month.')
          .test(
            'within-12-months',
            'The selected month must be within the past 12 months (including the current month).',
            (value) => {
              if (!(value instanceof Date) || isNaN(value.getTime()))
                return false;
              const now = new Date();
              const earliest = new Date(
                now.getFullYear(),
                now.getMonth() - 11,
                1
              );
              const latest = new Date(now.getFullYear(), now.getMonth() + 1, 0);
              return value >= earliest && value <= latest;
            }
          ),
      otherwise: (schema) =>
        schema
          .required('Please select a date.')
          .typeError('Please select a valid date.')
          .test(
            'is-valid-date',
            'Please select a date after 1 January 1970.',
            (value) => {
              return value instanceof Date && value.getTime() > 0;
            }
          ),
    }),
  startOfWeek: Yup.date().nullable().notRequired(),
});
